var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import ProductRecoSlider from '@empiriecom/module-components/ProductRecoSlider';
import BrandRecoSlider from '@empiriecom/module-components/BrandRecoSlider';
import CategoryRecoSlider from '@empiriecom/module-components/CategoryRecoSlider';
export var StyledRecoWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 0 4rem 0;\n  padding: 0;\n"], ["\n  margin: 0 0 4rem 0;\n  padding: 0;\n"])));
var Recommendations = function (_a) {
    var contentData = _a.contentData, _b = _a.recoApi, recoApi = _b === void 0 ? '/api/inform/graphql/' : _b;
    // Playground: https://baurde.empirie.cloud/api/inform/graphql/
    var cardLayout = false;
    var _c = contentData.field_text, headline = _c === void 0 ? '' : _c, headlineSpacer = contentData.field_headline_separator, _d = contentData.field_shop_id, shopID = _d === void 0 ? '' : _d, _e = contentData.field_reco_service, recoService = _e === void 0 ? '' : _e;
    var RecoComponent = function () {
        switch (recoService) {
            case 'prudsysCategoryToProducts':
            case 'prudsysCategoryToProductsPapi':
            case 'prudsysUserToProductsPapi':
            case 'prudsysHomePage':
                return (React.createElement(StyledRecoWrapper, { className: "cms-recommendation-wrapper has-rendered", "data-testid": "cms-recommendation" },
                    React.createElement(ProductRecoSlider, { headline: headline, headlineElement: "div", headlineSpacer: headlineSpacer, cardLayout: cardLayout, rdeRequest: {
                            rdeType: recoService,
                            articleNo: '',
                            cid: shopID,
                        }, recoApi: recoApi, pageTemplate: "homepage" })));
            case 'prudsysCategoryToCategories':
                return (React.createElement(StyledRecoWrapper, { className: "cms-recommendation-wrapper has-rendered", "data-testid": "cms-recommendation" },
                    React.createElement(CategoryRecoSlider, { recoApi: recoApi, cid: shopID })));
            case 'prudsysCategoryToBrands':
                return (React.createElement(StyledRecoWrapper, { className: "cms-recommendation-wrapper has-rendered", "data-testid": "cms-recommendation" },
                    React.createElement(BrandRecoSlider, { headline: headline, recoApi: recoApi, allBrandsLink: "/", cid: shopID })));
            case 'prudsysCategoryToBrandsPapi':
                return (React.createElement(StyledRecoWrapper, { className: "cms-recommendation-wrapper has-rendered", "data-testid": "cms-recommendation" },
                    React.createElement(BrandRecoSlider, { headline: headline, recoApi: recoApi, allBrandsLink: "/", cid: shopID, usePapi: true })));
            default:
                return React.createElement("div", { className: "no-render-result", "data-testid": "cms-recommendation-no-result" });
        }
    };
    return RecoComponent();
};
export default Recommendations;
var templateObject_1;
//# sourceMappingURL=index.js.map